import log from "loglevel";
export function logError(error) {
    log.error(error);
    alert(error);
}
//# sourceMappingURL=error.js.map